/* Form view */
import React from 'react';
import StyleColor from 'components/util/helpers/StyleColor';
import { StyleTag } from 'seed/helpers';
import { FORM_STATUS } from './Form.lib';
import { SchemaComponent, MessageComponent } from "./FormView.sub.view"

const FormView = ({
  flow,
  nodeId,
  formTitle,
  formStatus,
  schema,
  styleScript,
  validationMessage,
  reqUser,
  fullscreenStyles = true,
  onFormSubmit
}) =>
  <main id="form" role="main" className={fullscreenStyles ? "main pl-0 vw-100 vh-100 overflow-auto" : ""}>
    <StyleColor theme={flow?.theme ?? {}} />
    {styleScript && <StyleTag content={styleScript} />}

    <div class="container py-5 py-sm-10">
      <div class="row justify-content-center">

        {/* Show form if is active and has schema defined */}
        {formStatus == FORM_STATUS.ACTIVE && schema &&
          <div className={fullscreenStyles ? "col-md-9 col-lg-7" : "col-12"}>
            <SchemaComponent
              flowId={flow?.id}
              nodeId={nodeId}
              formTitle={formTitle}
              schema={schema}
              onFormSubmit={onFormSubmit}
              validationMessage={validationMessage}
            />
          </div>}

        {/* Message for other statuses */}
        {formStatus != FORM_STATUS.ACTIVE &&
          <div class="col-md-9 col-lg-7">
            <MessageComponent
              flow={flow}
              formStatus={formStatus}
              reqUser={reqUser}
            />
          </div>}
      </div>

    </div>
  </main>

export default FormView;